export default __webpack_public_path__ + "static/media/chrome.e0018ae8.gif";